import React, { ReactNode, useState } from "react";
import Time from "../../../../components/Time";
import ThreatStatusLabel from "../../../../components/ThreatStatusLabel";
import Icon from "../../../../components/Icon";
import { convertGoodwareClassification } from "./RlCloudSandboxUtil";
import RenderWhen from "../../../../components/RenderWhen";
import RlcsClassificationMapModal from "./common/RlcsClassificationMapModal";

type RlCloudSandboxSummaryProps = {
  filename: string;
  data: {
    sha1: string;
    classification: string;
    classification_impact: string;
    risk_score: number;
    first_analysis: string;
    last_analysis: string;
    platforms: string;
    file_type_image: {
      alt_txt: string;
      image_path: string;
    };
  };
  screenshotsThumbnailComp: ReactNode;
};

const RlCloudSandboxSummary = ({
  filename = "",
  data,
  screenshotsThumbnailComp
}: RlCloudSandboxSummaryProps) => {
  const [showClassificationMapModal, setShowClassificationMapModal] =
    useState(false);
  const {
    sha1,
    classification,
    classification_impact: classificationImpact,
    risk_score: riskScore,
    first_analysis: firstAnalysis,
    last_analysis: lastAnalysis,
    platforms,
    file_type_image: { alt_txt: fileTypeAltTxt, image_path: fileTypeImagePath }
  } = data || {};

  const [classificationLabel, classificationIcon]: string[] =
    convertGoodwareClassification(classification);

  return (
    <>
      <div className="rl-cloud-sandbox__summary">
        <div className="rl-cloud-sandbox__file-type-icon-container">
          <img src={fileTypeImagePath} alt={fileTypeAltTxt} />
        </div>

        <div className="rl-cloud-sandbox__summary-container">
          <div className="rl-cloud-sandbox__summary-data">
            <div>
              <strong>File Name:</strong> {filename}
            </div>
            <div>
              <strong>HASH:</strong> {sha1}
            </div>
            <div>
              <strong>Classification:</strong>
              {classification ? (
                <>
                  <ThreatStatusLabel
                    showColor
                    showOrb
                    threatStatus={classificationIcon}
                    labelText={classificationLabel}
                    riskScore={riskScore}
                    className="rlcs-orb-mapping"
                  />
                  {riskScore != null && (
                    <Icon
                      name="help"
                      className="rl-cloud-sandbox__classification-help-icon"
                      onClick={() => setShowClassificationMapModal(true)}
                    />
                  )}
                  <small className="text-color-lighter">
                    Highest-Level Classification from All Previous Analysis
                    Results. {classificationImpact}
                  </small>
                </>
              ) : (
                "-"
              )}
            </div>
            <div>
              <strong>First Analysis:</strong> <Time time={firstAnalysis} />
            </div>
            <div>
              <strong>Last Analysis:</strong> <Time time={lastAnalysis} />
            </div>
            <div>
              <strong>Platforms:</strong> {platforms}
            </div>
          </div>
          {screenshotsThumbnailComp}
        </div>
      </div>
      <RenderWhen condition={showClassificationMapModal}>
        <RlcsClassificationMapModal
          show={showClassificationMapModal}
          setShow={() =>
            setShowClassificationMapModal(!showClassificationMapModal)
          }
        />
      </RenderWhen>
    </>
  );
};

export default RlCloudSandboxSummary;
